<template>
  <div class="p-the-header-navi-on-general">
    <div class="p-the-header-navi-on-general__drawer__body">
      <button
        v-if="pager.hierarchy > 0 && pager.text"
        v-touch:tap
        class="p-the-header-navi-on-general__prev"
        @click="
          setChildItemObject(
            {
              key: -1,
              children: true,
              refsName: 'categoryNavi',
              pagerObj: {
                hierarchy: -1,
                text: 'メインメニュー'
              }
            },
            false
          )
        "
      >
        <i class="p-the-header-navi-on-general__prev__icon">
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            icon-color="#000000"
          >
            <IconArrowLeft3sticks />
          </IconBase>
        </i>
        <span class="p-the-header-navi-on-general__prev__text">{{
          pager.text
        }}</span>
      </button>

      <div ref="navi" class="p-the-header-navi-on-general__drawer__navi">
        <TheHeaderNaviOfUserMenu
          class="p-the-header-navi-on-general__navi"
          :point="point"
          :unit="unit"
          :icon-color="iconColor"
          :whats-new-unread-count="whatsNewUnreadCount"
          :thanks-point-unread-count="thanksPointUnreadCount"
        />

        <TheHeaderNaviOfSubMenu
          v-if="false"
          class="p-the-header-navi-on-general__navi p-the-header-navi-on-general__navi--service"
          :icon-color="iconColor"
        >
          <template #category>
            <TheHeaderNaviOfCategoryMenu
              v-model:pager="pager"
              v-model:shown="shown"
              v-model:data-of-pager-before-formatting="
                dataOfPagerBeforeFormatting
              "
              :icon-color="iconColor"
              @animation-child-item="animationChildItem"
            />
          </template>
        </TheHeaderNaviOfSubMenu>

        <TheHeaderNaviOfOtherMenu
          class="p-the-header-navi-on-general__navi p-the-header-navi-on-general__navi--other"
          :icon-color="iconColor"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import { gsap } from "gsap";

import IconBase from "@/common/components/atoms/IconBase.vue";

import IconArrowLeft3sticks from "@/common/components/icons/IconArrowLeft3sticks.vue";
import TheHeaderNaviOfUserMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfUserMenu.vue";
import TheHeaderNaviOfSubMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfSubMenu.vue";
import TheHeaderNaviOfCategoryMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfCategoryMenu.vue";
import TheHeaderNaviOfOtherMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfOtherMenu.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";

@Options({
  name: "TheHeaderNaviOnGeneral",
  props: {
    whatsNewUnreadCount: { type: Number, required: false, default: 0 },
    thanksPointUnreadCount: { type: Number, required: false, default: 0 },
    point: { type: Number, required: true }
  },
  components: {
    IconBase,
    IconArrowLeft3sticks,
    TheHeaderNaviOfUserMenu,
    TheHeaderNaviOfSubMenu,
    TheHeaderNaviOfCategoryMenu,
    TheHeaderNaviOfOtherMenu
  },
  watch: {
    dataOfPagerBeforeFormatting() {
      this.formatChildItemObject();
    }
  }
})
export default class TheHeaderNaviOnGeneral extends Vue {
  whatsNewUnreadCount!: number;
  thanksPointUnreadCount!: number;
  point!: number;

  pager = {
    hierarchy: 0,
    text: false,
    refsName: false,
    oldRefsName: false,
    key: false,
    oldKey: false
  };

  iconColor = "#3c3c3c";
  shown = false;

  get unit() {
    return commons.unit;
  }
  // get point() {
  //   return commons.point;
  // }

  dataOfPagerBeforeFormatting: any = {};

  animationChildItem(emitObj: any) {
    const navi = this.$refs.navi as HTMLElement;
    const { speed, width, shown } = emitObj;
    const prefix = shown === true ? "-=" : "+=";

    gsap.to(navi, speed, {
      x: `${prefix}${width}rem`
    });
  }

  setChildItemObject(paramsObj: any, shown = true) {
    this.dataOfPagerBeforeFormatting = {
      paramsObj,
      shown
    };
  }

  formatChildItemObject() {
    const { paramsObj, shown } = this.dataOfPagerBeforeFormatting;
    const { key, children, refsName, pagerObj } = paramsObj;
    const { hierarchy, text } = pagerObj;

    if (children === false) {
      return;
    }

    this.setPagerObject(
      {
        hierarchy,
        text,
        refsName,
        key
      },
      shown
    );
  }

  setPagerObject({ hierarchy, text, refsName, key }: any, shown: any) {
    const { pager } = this;
    let initHierarchy = hierarchy;

    if (hierarchy < 0) {
      initHierarchy = pager.hierarchy - 1;
    }

    if (initHierarchy < 0) {
      initHierarchy = 0;
    }

    const oldRefsName = pager.refsName;
    const oldKey = pager.key;

    this.pager = {
      hierarchy: initHierarchy,
      text,
      refsName,
      oldRefsName,
      key,
      oldKey
    };

    this.shown = shown;
  }
}
</script>

<style lang="scss" scoped>
.p-the-header-navi-on-general {
  &__prev {
    display: flex;
    padding: rem(13) rem(16);
    width: 100%;
    align-items: center;
    text-align: left;

    &__icon {
      line-height: 1;
      display: block;
      margin-right: rem(4);
    }

    &__text {
      font-size: rem(14);
      line-height: 1.6;
      flex-grow: 1;
      display: block;
      margin-bottom: rem(3);
    }
  }
}
</style>

<style lang="scss">
.p-the-header-navi-on-general {
  &__navi {
    width: 100%;

    &--service {
      margin-top: rem(32);
    }

    &--other {
      margin-top: rem(20);
      padding-top: rem(20);
      position: relative;

      &::before {
        content: "";
        display: block;
        width: calc(100% - 2.2857142857142856rem);
        height: px(2);
        margin: auto;
        left: 0;
        right: 0;
        top: 0;
        position: absolute;
        background-color: $common-gray500;
      }
    }

    &--child {
      visibility: hidden;
      opacity: 0;
      position: absolute;
      left: rem(16);
      top: 0;
      transform: translateX(100%);
    }

    &--grandchild {
      left: rem(32);
    }

    &__item {
      width: 100%;
    }
  }

  &__point {
    margin: 0 0 rem(8) rem(24 + 8);
    padding: 0 rem(16);

    &__text {
      font-size: rem(10);
    }
  }

  &__link {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: rem(12) rem(16);
    text-align: left;

    &__icon {
      display: block;
      line-height: 1;
      margin-right: rem(8);
    }

    &__text {
      font-size: rem(16);
      line-height: 1.6;
      flex-grow: 1;
      display: block;
      margin-bottom: rem(3);
      font-weight: bold;

      &--child {
        font-size: rem(14);
        font-weight: normal;
      }
    }

    &__arrow {
      line-height: 1;
    }
  }
}
</style>
